import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-upload-image-file',
  templateUrl: './upload-image-file.component.html',
  styleUrls: ['./upload-image-file.component.css'],
})
export class UploadImageFileComponent implements OnInit {
  isFileOpen: { state: boolean; url: any; isDWG: boolean; } = { state: false, url: '', isDWG: false };
  @Input() editFiles: '';
  @Output() shareImage = new EventEmitter<any>();
  @Output() mainImage = new EventEmitter<any>();
  imageBase64: string;
  exImg: string;

  constructor() { }

  ngOnInit(): void {
    this.imageBase64 = this.editFiles;
    if (!this.editFiles?.includes('https://')) {
      this.exImg = this.editFiles;
    }
  }

  // Recebe imagem, converte para base64 e guarda dentro do formulário
  setImage(event): void {
    const reader = new FileReader();
    reader.onload = (img) => {
      this.imageBase64 = img.target.result as string;
      this.exImg = this.imageBase64.split(',')[1];
      this.shareImage.emit([event[0], this.exImg]);
    };
    reader.readAsDataURL(event[0]);
  }
}
